<script>
export default {
    name: 'BaseCalendarNavigationPeriodMonths',
};
</script>

<script setup>
import { computed, ref, watch } from 'vue';
import formatDate from '@/utils/format-date.ts';
import { getMonths } from '@/components/base-components/components/calendar/utils/periods.js';

const props = defineProps({
    value: {
        type:     Date,
        required: true,
    },
});

const emit = defineEmits({
    input: null,
});

const today = new Date();
const date = ref(new Date(props.value));

watch(() => props.value, () => {
    date.value = new Date(props.value);
});

const items = computed(() => getMonths(date.value));

function goToPrevious() {
    const previous = new Date(date.value);

    previous.setFullYear(previous.getFullYear() - 1);

    date.value = previous;
}

function goToNext() {
    const next = new Date(date.value);

    next.setFullYear(next.getFullYear() + 1);

    date.value = next;
}
</script>

<template>
    <div>
        <slot
            name="navigation"
            :label="formatDate(date.toString(), { year: 'numeric' })"
            :go-to-previous="goToPrevious"
            :go-to-next="goToNext"
        />

        <div class="grid grid-cols-3">
            <base-button
                v-for="item in items"
                :key="item.toISOString()"
                :text="item.getFullYear() !== value.getFullYear() || item.getMonth() !== value.getMonth()"
                :type="item.getFullYear() === value.getFullYear() && item.getMonth() === value.getMonth() ? 'secondary' : 'default'"
                :text-transform="false"
                @click="emit('input', item)"
            >
                <span class="relative flex items-center justify-center">
                    <span v-text="formatDate(item.toString(), { month: 'short' })" />
                    <span
                        v-if="item.getFullYear() === today.getFullYear() && item.getMonth() === today.getMonth()"
                        class="absolute mt-5 border-t-2 border-current w-full"
                    />
                </span>
            </base-button>
        </div>
    </div>
</template>
